export function getClosestScrollParent(el: HTMLElement | null): HTMLElement {
  if (!el || !(el instanceof HTMLElement)) {
    return document.documentElement;
  }

  try {
    let parent = el.parentElement;
    while (parent) {
      if (parent === document.body) {
        parent = parent.parentElement;
        continue;
      }

      const computedStyle = window.getComputedStyle(parent);
      const overflow = computedStyle.overflow;
      const overflowX = computedStyle.overflowX;
      const overflowY = computedStyle.overflowY;

      const isScrollable = /(auto|scroll|overlay)/.test(overflow + overflowX + overflowY);
      const hasScrollableDimension =
        (parent.clientHeight < parent.scrollHeight &&
          (overflowY === "auto" || overflowY === "scroll" || overflowY === "overlay")) ||
        (parent.clientWidth < parent.scrollWidth &&
          (overflowX === "auto" || overflowX === "scroll" || overflowX === "overlay"));

      if (isScrollable && hasScrollableDimension) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return document.documentElement;
  } catch {
    return document.documentElement;
  }
}

export function scrollToBottom(el: HTMLElement) {
  if (!el || !el.scrollTo) return;
  el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
}
